module.exports = __webpack_public_path__ + "img/z2.d86e0a80.png";